import { IIconSetMap, iconSetNames as sets } from '../icon-set/IconSet';
import names from './iconNames';

import defaultFacebook from './_default/facebook.inline.svg';
import defaultKakao from './_default/kakao.inline.svg';
import defaultKakaoGift from './_default/kakaoGift.inline.svg';
import defaultLine from './_default/line.inline.svg';
import defaultNaver from './_default/naver.inline.svg';
import defaultRakuten from './_default/rakuten.inline.svg';

import colorFacebook from './_wide_color/facebook.color.inline.svg';
import colorKakao from './_wide_color/kakao.color.inline.svg';
import colorKakaoGift from './_wide_color/kakaoGift.color.inline.svg';
import colorLine from './_wide_color/line.color.inline.svg';
import colorNaver from './_wide_color/naver.color.inline.svg';
import colorRakuten from './_wide_color/rakuten.color.inline.svg';

const iconSetMap: IIconSetMap = {
    [names.facebook]: {
        [sets.wide]: defaultFacebook,
        [sets.wideColor]: colorFacebook
    },
    [names.kakao]: {
        [sets.wide]: defaultKakao,
        [sets.wideColor]: colorKakao
    },
    [names.kakaoGift]: {
        [sets.wide]: defaultKakaoGift,
        [sets.wideColor]: colorKakaoGift
    },
    [names.line]: {
        [sets.wide]: defaultLine,
        [sets.wideColor]: colorLine
    },
    [names.naver]: {
        [sets.wide]: defaultNaver,
        [sets.wideColor]: colorNaver
    },
    [names.rakuten]: {
        [sets.wide]: defaultRakuten,
        [sets.wideColor]: colorRakuten
    }
};

export default iconSetMap;
